import { API_PATHS } from "../../config/ApiPaths";

export const apiRevenueSabayGame = (stateDate, endDate) => {
  return `${API_PATHS.sabayGameRevenue}?startDate=${stateDate}&endDate=${endDate}`;
};
